
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Dropdown, InputText } from "@ronuse/norseu/core/form";
import { Alignment, Scheme } from "@ronuse/norseu/core/variables";

export class InputTextPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        let alignLabelOptions = [
			{ label: "Alignment.LEFT", value: Alignment.LEFT },
			{ label: "Alignment.RIGHT", value: Alignment.RIGHT },
			{ label: "Alignment.TOP", value: Alignment.TOP },
			{ label: "Alignment.CENTER", value: Alignment.CENTER },
			{ label: "Alignment.TOP_CENTER", value: Alignment.TOP_CENTER },
			{ label: "Alignment.TOP_LEFT", value: Alignment.TOP_LEFT },
			{ label: "Alignment.TOP_RIGHT", value: Alignment.TOP_RIGHT },
			{ label: "Alignment.BOTTOM", value: Alignment.BOTTOM },
			{ label: "Alignment.BOTTOM_LEFT", value: Alignment.BOTTOM_LEFT },
			{ label: "Alignment.BOTTOM_RIGHT", value: Alignment.BOTTOM_RIGHT },
			{ label: "Alignment.BOTTOM_CENTER", value: Alignment.BOTTOM_CENTER },
		];

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <InputText seamlesslyFocusAttrs={false}/>
                                <InputText placeholder="With placeholder"/>
                                <InputText placeholder="Outlined" outlined/>
                                <InputText placeholder="Flushed" flushed/>
                                <InputText placeholder="Outlined and Flushed" outlined flushed/>
                                <InputText placeholder="Disabled" disabled/>
                                <InputText placeholder="No Style" noStyle/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Schemes</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <InputText placeholder="Skeleton" scheme={Scheme.SKELETON}/>
                                <InputText placeholder="Primary scheme" scheme={Scheme.PRIMARY}/>
                                <InputText placeholder="Secondary scheme" scheme={Scheme.SECONDARY}/>
                                <InputText placeholder="Success scheme" scheme={Scheme.SUCCESS} outlined/>
                                <InputText placeholder="info scheme" scheme={Scheme.INFO} flushed/>
                                <InputText placeholder="Warning scheme" scheme={Scheme.WARNING} outlined/>
                                <InputText placeholder="Danger scheme" scheme={Scheme.DANGER} outlined flushed/>
                                <InputText placeholder="Dark scheme" scheme={Scheme.DARK}/>
                                <InputText placeholder="Light scheme" scheme={Scheme.LIGHT}/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Label</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <InputText placeholder="e.g. Damilola" scheme={Scheme.PRIMARY} label="First name"/>
                                <InputText placeholder="e.g. Damilola" scheme={Scheme.PRIMARY} label={<i className="fa fa-user"/>}/>
                                <InputText scheme={Scheme.PRIMARY} label="Float Label" floatLabel/>
                                <InputText scheme={Scheme.PRIMARY} label="Last name" floatLabel flushed outlined/>
                                <InputText scheme={Scheme.PRIMARY} label={
                                    <label className="norseu-info-text fa fa-user"> Schemed And Styled Label</label>
                                }/>
                                <InputText scheme={Scheme.PRIMARY} label={
                                    <label>First name <span style={{color: "red"}}>*</span></label>
                                }/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Icon</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <InputText fill placeholder="Left icon only" scheme={Scheme.PRIMARY} leftIcon="fa fa-search" outlined/>
                                <InputText placeholder="Right icon only" scheme={Scheme.PRIMARY} rightIcon="fa fa-spinner fa-pulse" outlined/>
                                <InputText placeholder="Right and left icon only" scheme={Scheme.PRIMARY} leftIcon="fa fa-user" rightIcon="fa fa-cog fa-spin"/>
                                <InputText placeholder="Custom Icon" scheme={Scheme.PRIMARY} leftIcon={
                                    <img alt="norseu" src="https://avatars3.githubusercontent.com/u/14879387?s=16" style={{borderRadius:"50%"}}/>
                                } outlined/>
                                <InputText placeholder="Custom left and right icon" scheme={Scheme.PRIMARY} leftIcon="fab fa-google" rightIcon="fab fa-twitter" outlined flushed/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Help Label</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <InputText scheme={Scheme.PRIMARY} label="Username"
                                    helpLabel="Enter your username to login to  your account" alignHelpLabel={Alignment.TOP}/>
                                <InputText scheme={Scheme.PRIMARY} label="Clear Password" 
                                    alignLabel={Alignment.TOP} 
                                    helpLabel={<div><i className="fa fa-info"/> <small>Hint: The new password must at least seven characters long.</small><br/>
                                        <small>To make it stronger use upper and lower case letters, numbers and</small><br/>
                                        <small>symbol like !, $, &, ), @.</small></div>}/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Label and Help Label Alignment</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                Label Alignment : <Dropdown options={alignLabelOptions} selectedOptionIndex={2} onSelectOption={(e) => this.setState({ alignLabel: e.option.value } )}/>
                                Help Label Alignment : <Dropdown options={alignLabelOptions} selectedOptionIndex={2} onSelectOption={(e) => this.setState({ alignHelpLabel: e.option.value } )}/>
                                <InputText fill placeholder="alignLabel={Alignment.?}" scheme={Scheme.PRIMARY} 
                                    label="Fullname" 
                                    helpLabel="Enter your username to login to  your accout"
                                    alignLabel={this.state.alignLabel}
                                    alignHelpLabel={this.state.alignHelpLabel}/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Controlled</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <span>Value: {this.state.inputValue}</span>
                                <InputText defaultValue={this.state.inputValue} placeholder="Enter you text here" scheme={Scheme.PRIMARY} onInput={(e) => this.setState({ inputValue: e.target.value })}/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "InputText",
            import_statement: "import { InputText } from '@ronuse/norseu/core/form'",
            properties: InputTextPage.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/form/InputTextPage.js"
        });
    }

    state = {
        alignLabel: Alignment.TOP,
        alignHelpLabel: Alignment.BOTTOM,
        pageSource: '',
        inputValue: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    static properties = [
        { name: "scheme", type: <a href='#/p/components/core/variables/scheme'>Scheme</a>, default: "null", description: "Set the text input appearance according to scheme" },
        { name: "id", type: "string", default: null, description: "Set the internal element id" },
        { name: "name", type: "string", default: null, description: "Set the internal input (type text) element name" },
        { name: "className", type: "string", default: null, description: "CSS classes to apply to the component" },
        { name: "style", type: "object", default: null, description: "CSS Style to apply to the component" },
        { name: "inputClassName", type: "string", default: null, description: "CSS classes to apply to the internal element that contains the HTML input and icons" },
        { name: "inputStyle", type: "object", default: null, description: "CSS Style to apply to the internal element that contains the HTML input and icons" },
        { name: "internalInputClassName", type: "string", default: null, description: "CSS classes to apply to the HTML input" },
        { name: "internalInputStyle", type: "object", default: null, description: "CSS Style to apply to the HTML input" },
        { name: "label", type: "string|element", default: null, description: "The label for the text input" },
        { name: "alignLabel", type: <a href='#/p/components/core/variables/alignment'>Alignment</a>, default: <a href='#/p/components/core/variables/alignment#top'>Alignment.TOP</a>, description: "The position to place the input label" },
        { name: "helpLabel", type: "string|element", default: null, description: "The help label for the text input" },
        { name: "alignHelpLabel", type: <a href='#/p/components/core/variables/alignment'>Alignment</a>, default: <a href='#/p/components/core/variables/alignment#bottom'>Alignment.BOTTOM</a>, description: "The position to place the input help label" },
        { name: "placeholder", type: "string", default: null, description: "The HTML input placeholder value" },
        { name: "outlined", type: "boolean", default: false, description: "Remove the fill effect" },
        { name: "flushed", type: "boolean", default: false, description: "Remove the component border except for bottom border" },
        { name: "noBorder", type: "boolean", default: false, description: "Remove all border from the component" },
        { name: "noStyle", type: "boolean", default: false, description: "Only render the element excluding any css/style property" },
        { name: "leftIcon", type: "string|element", default: null, description: "The component left icon, can be Font Awesome icon class name or valid react element" },
        { name: "rightIcon", type: "string|element", default: null, description: "The component right icon, can be Font Awesome icon class name or valid react element" },
        { name: "disabled", type: "boolean", default: false, description: "Disable the element, prevents it from receiving pointer event" },
        { name: "required", type: "boolean", default: false, description: "Set the component HTML input required attribute" },
        { name: "readOnly", type: "boolean", default: false, description: "Set the component HTML input readOnly attribute" },
        { name: "floatLabel", type: "boolean", default: false, description: "Make the component placeholder float on focus or has input" },
        { name: "filter", type: <a href='#/p/components/core/variables/inputfilter'>InputFilter</a>, default: null, description: "Set the input value filter" },
        { name: "type", type: "string", default: "text", description: "The type of the HTML input element" },
        { name: "fill", type: "boolean", default: false, description: "Make the button width match the parent width" },
        { name: "elementRef", type: "React.RefObject", default: null, description: "Set the internal HTML input element ref" },
        { name: "compoundRef", type: "React.RefObject", default: null, description: "Set the ref for the div that encompass the component" },
        { name: "defaultValue", type: "string", default: "", description: "The HTML input element default value" },
        { name: "seamlesslyFocusAttrs", type: "boolean", default: true, description: "Toggle the application of scheme and styling on the component on focus" },
        { name: "onKeyPress", type: "function", default: "(event, ref)", description: "The callback that is invoked when a key is pressed in the HTML input" },
        { name: "onInput", type: "function", default: "(event, ref)", description: "The callback that is invoked when an input event is sent to the HTML input" },
        { name: "onPasteCapture", type: "function", default: "(event, ref)", description: "The callback that is invoked when a paste event is sent to the HTML input" },
        { name: "onFirstInput", type: "function", default: "(event, ref)", description: "The callback that is invoked when the first character is pasted or entered in the HTML input" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}